import styled from 'styled-components'

import colors from '@settings/styleSettings'
import Modal from 'styled-react-modal'
import PrimaryButton from '@components/inputs/button/primaryButton'

export const SaveButton = styled(PrimaryButton)`
  width: 100%;
`
export const Container = Modal.styled`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 375px;
  position: absolute;
  height: ${(props) => props.clientHeight}px;
  right: 0;
  top: 0;
  background-color: ${colors.grayBackground};

  @media (max-width: 1025px) {
    max-width: 100%;
    width: 100%;
  }

  -webkit-animation-name: fadeInRight;
  animation-name: fadeInRight;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  @-webkit-keyframes fadeInRight {
    0% {
      opacity: 0;
      -webkit-transform: translate3d(100%, 0, 0);
      transform: translate3d(100%, 0, 0);
    }
    100% {
      opacity: 1;
      -webkit-transform: none;
      transform: none;
    }
  }
  @keyframes fadeInRight {
    0% {
      opacity: 0;
      -webkit-transform: translate3d(100%, 0, 0);
      transform: translate3d(100%, 0, 0);
    }
    100% {
      opacity: 1;
      -webkit-transform: none;
      transform: none;
    }
  }
`
export const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  height: 100px;
  margin-bottom: 5px;
  background-color: ${colors.background};

  @media (max-width: 330px) {
    height: 150px;
  }
`
export const FormFields = styled.div`
  background-color: ${colors.background};
  display: flex;
  flex-direction: column;
  padding: 24px;
  gap: 20px;
`

export const Section = styled.div`
  width: 100%;
  @media(max-height: 1000px) {
    overflow-y: scroll;

    ::-webkit-scrollbar {
      width: 0;
    }

    ::-webkit-scrollbar-track {
      display: none;
    }
  }
`

export const ButtonContainer = styled.div`
  width: -webkit-fill-available;
  width: -moz-available;
  position: sticky;
  bottom: 0;
  padding: 2rem;
  margin-top: auto;
  background-color: ${colors.background};
`
